import { ref, watch, computed } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'
import router from '@/router/index'

// Notification

export default function useEventBookingList() {
  // Use toast
  const toast = useToast()
  const route = router.history.current

  const refBookingsTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'stringID',
      label: 'ID',
      sortable: true,
    },
    {
      key: 'start',
      label: 'appt. time',
      sortable: true,
    },
    {
      key: 'packageID',
      label: 'Packages / Pricing',
      sortable: true,
    },
    {
      key: 'paymentRemarks',
      label: 'Payment remarks',
      sortable: true,
    },
    {
      key: 'customerName',
      label: 'Customer',
      sortable: true,
    },
    {
      key: 'agentName',
      label: 'Agent',
      sortable: true,
    },
    {
      key: 'createdBy',
      label: 'Created by',
      sortable: true,
    },
    { key: 'status', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(route.query.perPage ?? process.env.VUE_APP_PER_PAGE_CONTENT)
  const totalBookings = ref(0)
  const currentPage = ref(route.query.page ?? 1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref(route.query.search ?? '')
  const sortBy = ref(route.query.sortBy ?? 'stringID')
  const isSortDirDesc = ref(route.query.sortDesc === 'true')
  const statusFilter = ref([])
  if (Array.isArray(route.query.status)) {
    statusFilter.value = route.query.status
  } else if (route.query.status) {
    statusFilter.value = [route.query.status]
  }
  const startDateFilter = ref(route.query.startDate || '')
  const toDeletedID = ref(null)
  const type = ref('all-booking')
  const bookingData = ref([])
  // let initialLoad = true
  const event = ref(route.params.id || null)

  const dataMeta = computed(() => {
    const localItemsCount = refBookingsTable.value ? refBookingsTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalBookings.value,
    }
  })

  const refetchData = () => {
    refBookingsTable.value.refresh()
  }

  watch([searchQuery, statusFilter, startDateFilter], () => {
    currentPage.value = 1
    refetchData()
  }, { deep: true })

  watch([currentPage], () => {
    refetchData()
  }, { deep: true })

  const fetchBookings = (ctx, callback) => {
    store
      .dispatch('app-event-bookings/fetchBookings', {
        search: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
        startDate: startDateFilter.value,
        type: type.value,
        event: event.value,
      },
      { root: true })
      .then(response => {
        const { bookings, total } = response.data
        bookingData.value = bookings
        callback(bookings)
        totalBookings.value = total
        // if (!initialLoad) {
        //   router.replace({
        //     query: {
        //       search: searchQuery.value,
        //       perPage: perPage.value,
        //       page: currentPage.value,
        //       sortBy: sortBy.value,
        //       sortDesc: isSortDirDesc.value,
        //       status: statusFilter.value,
        //     },
        //   }).catch(() => {})
        // }
        // initialLoad = false
      })
      .catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const deleteBooking = () => {
    store
      .dispatch('app-event-bookings/deleteBooking', {
        id: toDeletedID.value,
      },
      { root: true })
      .then(response => {
        refetchData()
        toast({
          component: ToastificationContent,
          props: {
            title: response.data.message ?? '',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
      .catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveBookingStatusVariant = status => {
    if (status === 'confirmed') return 'success'
    if (status === 'pending-payment') return 'warning'
    if (status === 'pending-approval') return 'warning'
    if (status === 'waiting-list') return 'secondary'
    if (status === 'draft') return 'secondary'
    if (status === 'cancelled') return 'danger'
    return 'primary'
  }

  return {
    fetchBookings,
    tableColumns,
    perPage,
    currentPage,
    totalBookings,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refBookingsTable,

    resolveBookingStatusVariant,
    refetchData,

    toDeletedID,
    deleteBooking,
    type,
    bookingData,

    // Extra Filters
    statusFilter,
    startDateFilter,
  }
}
